import { render, staticRenderFns } from "./FiveYearsDurability.vue?vue&type=template&id=aab67bde&scoped=true"
import script from "./FiveYearsDurability.vue?vue&type=script&lang=js"
export * from "./FiveYearsDurability.vue?vue&type=script&lang=js"
import style0 from "./FiveYearsDurability.vue?vue&type=style&index=0&id=aab67bde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab67bde",
  null
  
)

export default component.exports